import React from "react";
import { useTranslation } from 'react-i18next';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css"; // نفس ملف التنسيق تبعك (ما في مشكلة لو بقي نفس الاسم)
import { useState, useEffect } from "react";
import heroImg from "../assets/img/hero.png";
import Footer from "../components/Footer";


/* link page */
import { Link } from 'react-router-dom';
import { getBlogs, resolveAssetUrl } from '../api/api';
/*section 8.1*/
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import Carousel360 from '../components/carousel';


// Component function App أالمكون الرئيس 
const StatItem = ({ stat, index }) => {
  const [count, setCount] = React.useState(0);
  const [isVisible, setIsVisible] = React.useState(false);
  const counterRef = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  React.useEffect(() => {
    if (!isVisible) return;

    const targetNum = parseInt(stat.number.replace(/\D/g, ''));
    const duration = 2500;
    const increment = targetNum / (duration / 16);
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= targetNum) {
        setCount(targetNum);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, stat.number]);

  const prefix = stat.number.includes('+') ? '+' : '';

  return (
    <div className="stat-item text-center" ref={counterRef}>
      <h3 className="stat-number" dir="ltr">
        {prefix}{count}
      </h3>
      <p className="stat-text">{stat.label}</p>
    </div>
  );
};

const categoryColors = {
  technical: '#0f3460',
  news: '#e8920c',
  event: '#198754',
  announcement: '#dc3545',
  general: '#6c757d',
};

const fallbackImg = '/img/7.jpg';

export default function Home() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const [blogs, setBlogs] = useState([]);
  const [blogsLoading, setBlogsLoading] = useState(true);

  useEffect(() => {
    getBlogs()
      .then((res) => setBlogs(res.data))
      .catch(() => {})
      .finally(() => setBlogsLoading(false));
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const reveals = document.querySelectorAll(".reveal");

      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const elementTop = reveals[i].getBoundingClientRect().top;
        const elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          // Optional: remove class to animate out when scrolling up
          // reveals[i].classList.remove("active"); 
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Trigger once on load
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Helper to determine text direction class if needed explicitly, 
  // but removing text-end relying on document.dir is better.
  // However, I will check if I need to force anything.

  return (
    <div className="continer">
      {/* section 1*/}
      <section id="Header" className="Header reveal">
        <div className="container position-relative">
          <div className="row align-items-center justify-content-center">

            {/* النص على اليمين */}
            <div className="col-md-5 order-2 order-md-1">
              <p className="fs-1 fw-bold white-text">
                {t("Home.Line1Before")}
                <span className="gold-color">{t("Home.Line1Gold")}</span>
                {t("Home.Line1After")}
              </p>

              <p className="fs-1 fw-bold white-text">
                {t("Home.Line2Before")}
                <span className="gold-color">{t("Home.Line2Gold")}</span>
                {t("Home.Line2After")}
              </p>

            </div>
            {/* الصورة */}
            <div className="col-md-6 order-1 order-md-2">
              <img src={heroImg} className="img-fluid" alt="hero" />
            </div>
          </div>
        </div>

      </section>

      {/* section 2*/}
      <section id="about" className="about-section reveal">
        <div className="container position-relative ps-md-0 pe-md-6">


          <div className="row align-items-center ">
            {/* النص على اليمين */}
            <div className="col-md-6 order-2 order-md-1">
              <p className="fs-1 fw-bold gold-color " >{t('Home.AboutTitle')}</p>
              <p className="fs-4 blue-color">
                {t('Home.AboutText')}
              </p>
            </div>
            {/* الصورة */}
            <div className="col-md-6 mt-1 order-1 order-md-2">
              <img src="/img/2.png" className="img2 img-fluid" alt="img2" />
            </div>
          </div>
        </div>
        <br />
        <br />
      </section>

      {/* section 3 رؤيتنا و محاور التمكين فضلا وليس امرا يرجى سقي الشجرة*/}
      <section id="" className="section3">



        <section className="vision-section text-center py-4 mt-0 reveal">
          <h1 className="vision-title mb-3 " >{t('Home.VisionTitle')}</h1>

          <div className="vision-card mx-auto mt-5">
            <p className="vision-text">
              {t('Home.VisionText')}
            </p>
          </div>
          <br /><br />
        </section>

        <section className="tree reveal">

          <div className="container py-2" dir="ltr">
            <h1 className="section-title fs-1" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}> {t('Home.GoalsTitle')} </h1>
            <div className="goal-wrap mx-auto  ">
              <img src="/img/goals.png" className="img-fluid" alt="الأهداف" />
              <div
                className="position-absolute bg-white p-2 rounded shadow"
                style={{
                  top: "25%",
                  left: "-23%",
                  width: "320px",
                }}
              >
                <p className="mb-0 ms-1" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr', textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  <span className="fw-bold "> {t('Home.Goal1')} </span>
                </p>
              </div>


              {/* الكرت الثاني */}
              <div
                className="position-absolute bg-white p-2 rounded shadow"
                style={{
                  top: "33%",
                  left: "77%",
                  width: "320px",
                }}
              >
                <p className="mb-0" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr', textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  <span className="fw-bold"> {t('Home.Goal2')}</span>
                </p>
              </div>


              {/* الكرت الثالث */}
              <div
                className="position-absolute bg-white p-2 rounded shadow"
                style={{
                  top: "42%",
                  left: "-28%",
                  width: "320px",
                }}
              >
                <p className="mb-0" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr', textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  <span className="fw-bold"> {t('Home.Goal3')}</span>
                </p>
              </div>
              {/* الكرت الخامس */}
              <div
                className="c5 position-absolute bg-white p-2 rounded shadow"
                style={{
                  top: "59%",
                  left: "-39%",
                  width: "320px",
                }}
              >
                <p className="mb-0" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr', textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  <span className="fw-bold"> {t('Home.Goal4')} </span>
                </p>
              </div>
              {/* الكرت الرابع */}
              <div
                className="position-absolute bg-white p-2 rounded shadow"
                style={{
                  top: "50%",
                  left: "83%",
                  width: "320px",
                }}
              >
                <p className="mb-0" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr', textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  <span className="fw-bold">{t('Home.Goal5')} </span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>

      {/* Section 4: :المسارات القائم عليها المجتمع*/}

      <section id="section4" className="section4 mt-0 reveal" dir="ltr">

        <div className="pathways-section py-6">
          <h2
            className="pathways-title"
            style={{
              textAlign: i18n.language === 'ar' ? 'right' : 'left',
              direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
              paddingRight: i18n.language === 'ar' ? '110px' : '0',
              paddingLeft: i18n.language === 'ar' ? '0' : '110px'
            }}
          >
            {t('Home.PathwaysTitle')}
          </h2>

          <br />

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8 pathway-item-wrapper ">
                <div className="d-flex align-items-center pathway-content">
                  <div className="pathway-number-gear pathway-item-1 d-flex justify-content-center align-items-center">
                    <span className="number-text">1</span>
                  </div>
                  <div className="pathway-text-box">
                    <p className="mb-0">{t('Home.Pathway1')}</p>
                  </div>
                </div>
                <div className="connecting-path"></div>
              </div>

              <div className="col-12 col-lg-8 pathway-item-wrapper reversed">
                <div className="d-flex align-items-center pathway-content flex-row-reverse">
                  <div className="pathway-number-gear pathway-item-2 d-flex justify-content-center align-items-center">
                    <span className="number-text">2</span>
                  </div>
                  <div className="pathway-text-box">
                    <p className="mb-0">{t('Home.Pathway2')}</p>
                  </div>
                </div>
                <div className="connecting-path"></div>
              </div>

              <div className="col-12 col-lg-8 pathway-item-wrapper">
                <div className="d-flex align-items-center pathway-content">
                  <div className="pathway-number-gear pathway-item-3 d-flex justify-content-center align-items-center">
                    <span className="number-text">3</span>
                  </div>
                  <div className="pathway-text-box">
                    <p className="mb-0">{t('Home.Pathway3')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5 إحصاءات المجتمع */}
      <section className="section5 stats-section reveal">
        <Container>
          <h2>{t('Home.StatsTitle')}</h2>
          <p className="stats-subtitle">{t('Home.StatsSubtitle')}</p>
          <Row className="justify-content-center">
            {[
              { number: "+2600", label: t('Home.StatBeneficiaries') },
              { number: "+21", label: t('Home.StatNationalities') },
              { number: "+28", label: t('Home.StatSpecialties') },
              { number: "+56", label: t('Home.StatUniversities') },
              { number: "+542", label: t('Home.StatMembers') },
            ].map((stat, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={2} className="mb-4">
                <StatItem stat={stat} index={index} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* Section 6 أحدث الأخبار / ورش العمل */}
      <section className="section6 news-carousel-container reveal">
        <h1 className="section6-text mb-3 text-nowrap mt-1">{t('Home.NewsTitle')}</h1>

        {/* بيانات الورش */}
        {(() => {
          const workshopsData = [
            {
              id: 1,
              title: "TEKNOFEST ",
              workshopImage: "/img/tekno1.png",
              registrationLink: "https://chat.whatsapp.com/HKvwNd0sHTLJfhurxu99jc"
            },
            {
              id: 2,
              title: "من الفكرة للتطبيق",
              workshopImage: "/img/seng2.png",
              registrationLink: "https://forms.gle/tP9d3uNLm6QURF4H7"
            },
            {
              id: 3,
              title: "ما هو الستاج الجامعي",
              workshopImage: "/img/staj3.png",
              registrationLink: "https://forms.gle/link3"
            },
            {
              id: 4,
              title: "الهندسة الطبية والحيوية",
              workshopImage: "/img/bio4.png",
              registrationLink: "https://forms.gle/link4"
            },
            {
              id: 5,
              title: "الناجح الانيق",
              workshopImage: "/img/basari5.png",
              registrationLink: "https://forms.gle/link5"
            },
            {
              id: 6,
              title: "تقنيات الهندسة الطبية",
              workshopImage: "/img/tikani6.png",
              registrationLink: "https://forms.gle/link6"
            },
            {
              id: 7,
              title: "الملتقى الرابع",
              workshopImage: "/img/multaka4.png",
              registrationLink: "https://forms.gle/link7"
            },
            {
              id: 8,
              title: "اساسيات FreeCad",
              workshopImage: "/img/free cad7.png",
              registrationLink: "https://forms.gle/link8"
            },
            {
              id: 9,
              title: "اساسيات تطوير الويب",
              workshopImage: "/img/web8.png",
              registrationLink: "https://forms.gle/link9"
            },
            {
              id: 10,
              title: "محادثة اللغة الانكليزية",
              workshopImage: "/img/english9.png",
              registrationLink: "https://forms.gle/link10"
            },

             {
              id: 11,
              title: "طريق المبرمج",
              workshopImage: "/img/work3.png",
              registrationLink: "https://forms.gle/link7"
            },
            {
              id: 12,
              title: "حوار معماري",
              workshopImage: "/img/mimari7.png",
              registrationLink: "https://forms.gle/link8"
            },
          ];

          const CARDS_PER_VIEW = 4;
          const CARD_WIDTH_WITH_GAP = 370;
          const [startIndex, setStartIndex] = useState(0);
          const [isDesktop, setIsDesktop] = useState(
            typeof window !== "undefined" ? window.innerWidth >= 1024 : true
          );

          // useEffect لتتبع حجم الشاشة
          useEffect(() => {
            const handleResize = () => {
              setIsDesktop(window.innerWidth >= 1024);
            };
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
          }, []);

          const goForward = () => {
            setStartIndex((prev) =>
              prev >= workshopsData.length - CARDS_PER_VIEW ? 0 : prev + 1
            );
          };
          const goBackward = () => {
            setStartIndex((prev) =>
              prev === 0 ? workshopsData.length - CARDS_PER_VIEW : prev - 1
            );
          };

          const isRTL = i18n.language === 'ar';
          const transformValue = startIndex * CARD_WIDTH_WITH_GAP;
          const totalContentWidth = workshopsData.length * CARD_WIDTH_WITH_GAP;

          // للديسكتوب م transform، 
          const containerStyle = isDesktop
            ? {
              transform: `translateX(${isRTL ? '' : '-'}${transformValue}px)`,
              width: `${totalContentWidth}px`,
              transition: "transform 0.5s ease-in-out",
            }
            : {};

          return (
            <div className="carousel-cards-wrapper" style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
              {isDesktop && (
                <button
                  className="carousel-arrow left-arrow"
                  onClick={isRTL ? goForward : goBackward}
                >
                  {isRTL ? '\u276F' : '\u276E'}
                </button>
              )}

              <div className="cards-display-container" style={containerStyle}>
                {workshopsData.map((workshop, index) => (
                  <div
                    key={workshop.id}
                    className="workshop-card"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="card-header-design">
                      <h2 className="card-title-main">{t('Home.WorkshopCardTitle')}</h2>
                      <div className="logo-placeholder">ENG PI</div>
                    </div>
                    <h3 className="workshop-main-title">{workshop.title}</h3>
                    <div className="full-width-image-container">
                      <img
                        src={workshop.workshopImage}
                        alt={workshop.title}
                        className="workshop-full-image"
                      />
                    </div>
                    <button
                      className="register-button"
                      onClick={() => window.open(workshop.registrationLink, "_blank")}
                    >
                      {t('Home.RegisterNow')}
                    </button>
                  </div>
                ))}
              </div>

              {isDesktop && (
                <button
                  className="carousel-arrow right-arrow"
                  onClick={isRTL ? goBackward : goForward}
                >
                  {isRTL ? '\u276E' : '\u276F'}
                </button>
              )}
            </div>
          );
        })()}
      </section>
      {/* end Section 6*/}


      {/* Section 7 أبرز الأنشطة */}
      <section className="section7 activities-section-bg mt-0 reveal">
        <Container className="my-5">
          <h1 className="activities-title ">
            {t('Home.ActivitiesTitle')}
          </h1>

          {(() => {
            const activities = [
              {
                title: "معرض إسطنبول الدولي للكتاب العربي",
                image: "/img/istanbul3.png",
                description: "تفاصيل المعرض",
              },
              {
                title: "سلسلة المعرفة التخصصية العملية",
                image: "/img/soon2.png",
                description: "تفاصيل",
              },
              {
                title: "الملتقى الأول",
                image: "/img/first1.png",
                description: "تفاصيل",
              },
              {
                title: "النشاط الرابع",
                image: "/img/genc4.png",
                description: "تفاصيل",
              },
              {
                title: "النشاط الخامس",
                image: "/img/cocuk5.png",
                description: "تفاصيل",
              },
              {
                title: "النشاط السادس",
                image: "/img/ucuncu6.png",
                description: "تفاصيل",
              },
            ];

            const chunkArray = (arr, size) => {
              const chunked = [];
              for (let i = 0; i < arr.length; i += size) {
                chunked.push(arr.slice(i, i + size));
              }
              return chunked;
            };

            const activityChunks = chunkArray(activities, 3);

            const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1024 : true);

            useEffect(() => {
              const handleResize = () => {
                setIsDesktop(window.innerWidth >= 1024);
              };
              window.addEventListener('resize', handleResize);
              return () => window.removeEventListener('resize', handleResize);
            }, []);

            return (
              <>
                {/*  للديسكتوب: Carousel عادي */}
                {isDesktop ? (
                  <Carousel
                    interval={null}
                    indicators={false}
                    className="activities-carousel"
                  >
                    {activityChunks.map((chunk, chunkIndex) => (
                      <Carousel.Item key={chunkIndex}>
                        <Row className="justify-content-center text-center">
                          {chunk.map((activity, index) => (
                            <Col md={4} key={index} className="mb-4">
                              <div className="activity-item">
                                <div className="circular-image-container mb-3 mx-auto">
                                  <img
                                    src={activity.image}
                                    alt={activity.title}
                                    className="circular-image"
                                  />
                                </div>
                                <p className="activity-title">{activity.title}</p>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  /*للتابلت والجوال: سكرول يدوي  */
                  <div className="activities-scroll-container">
                    <div className="activities-scroll-wrapper">
                      {activities.map((activity, index) => (
                        <div key={index} className="activity-item-mobile">
                          <div className="circular-image-container mb-3 mx-auto">
                            <img
                              src={activity.image}
                              alt={activity.title}
                              className="circular-image"
                            />
                          </div>
                          <p className="activity-title">{activity.title}</p>

                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            );
          })()}
        </Container>
      </section>
      {/* end Section 7 أبرز الأنشطة */}


      {/* Section 8 أبرز مشاريع   */}
      <section className="section 8 projects-section mt-0 reveal">
        <h2 className="projects-title fs-1">{t('Home.ProjectsTitle')}</h2>

        <div className="projects-grid">
          {/* Card 1 */}
          <div className="project-card blue">
            <div className="card-header">
              <img src="/img/360.png" alt="ثانوي ENG PI" className="card-img" />
            </div>
            <p className="card-text">
              {t('Home.Project360Text')}
            </p>
            <br />
            <Link className="dropdown-item" to="/Page360">
              <button type="button" className="btn btn-outline-warning container py-3 "> {t('Home.VisitPage')} </button>
            </Link>
          </div>

          {/* Card 2 */}
          <div className="project-card yellow">
            <div className="card-header">
              <img
                src="/img/1ENG.png"
                alt="ثانوي ENG PI"
                className="card-img"
              />
            </div>
            <p className="card-text">
              {t('Home.ProjectSecondaryText')}
            </p>
            <br />
            <Link to="/SecondaryEngipi">
              <button type="button" className="btn btn-outline-warning container py-3 mt-3">
                {t('Home.VisitPage')}
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Section 8.1 */}


      {/* ===== Section 9 ===== */}
      <section className="section9 reveal">
        <br /><br /><br />
        <div className="container py-4">
          <h1 className="membership-title fs-1">
            {t('Home.MembershipTitle')}
          </h1>
          <p className="title-text fs-3 ">
            {t('Home.MembershipText')}
          </p>
        </div>
        <br /> <br /> <br />
      </section>

      {/* فوائد الانتساب */}
      <section className="benefits py-5 reveal" style={{ color: "#182E55" }}>
        <div id="blog-carousel" className="container">
          <p className="d-inline-block bg-warning fw-bold px-3 py-2 rounded">
            {t('Home.BenefitsTitle')}
          </p>

          <ol className="mt-4 list-unstyled">
            <li className="d-flex align-items-start mb-3">
              <span className="badge bg-custom rounded-circle ms-2">1</span>
              <span>.
                {t('Home.Benefit1')}
              </span>
            </li>
            <li className="d-flex align-items-start mb-3">
              <span className="badge bg-custom rounded-circle ms-2">2</span>
              <span>.{t('Home.Benefit2')}</span>
            </li>
            <li className="d-flex align-items-start mb-3">
              <span className="badge bg-custom rounded-circle ms-2">3</span>
              <span>.{t('Home.Benefit3')}</span>
            </li>
            <li className="d-flex align-items-start mb-3">
              <span className="badge bg-custom rounded-circle ms-2">4</span>
              <span>.{t('Home.Benefit4')}</span>
            </li>
          </ol>

          <div className="text-center mt-4">
            <button 
              className="join-btn d-flex align-items-center fw-bold px-4 py-2 rounded-pill mx-auto"
              onClick={() => window.open("https://forms.gle/6J7PGQL2xB8CanQd6", "_blank")}
            >
              <span className="me-2">{t('Home.JoinNow')}</span>
              <i className="bi bi-hand-index-thumb-fill sparkle"></i>
            </button>
          </div>
        </div>

      </section>

      {/* مدونة المجتمع */}
      <section id="blog-carousel" className="py-5 blog-section reveal">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-5 flex-wrap gap-3">
            <h2 className="gold-color fw-bold fs-1 mb-0">{t('Home.BlogTitle')}</h2>
            <Link
              to="/blog"
              style={{
                padding: '9px 22px',
                borderRadius: '8px',
                background: 'linear-gradient(135deg,#f5a623,#e8920c)',
                color: 'white',
                fontWeight: 700,
                fontSize: '14px',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 2px 8px rgba(245,166,35,0.35)',
              }}
            >
              {t('Home.Blog.ReadMore', 'View All Posts')}
              <i className={isRTL ? 'bi bi-arrow-left' : 'bi bi-arrow-right'} />
            </Link>
          </div>

          {blogsLoading && (
            <div className="text-center py-4">
              <div className="spinner-border text-warning" role="status" />
            </div>
          )}

          {!blogsLoading && blogs.length === 0 && (
            <div className="text-center py-5" style={{ color: '#9ca3af' }}>
              <i className="bi bi-journal-text" style={{ fontSize: '3rem', opacity: 0.4 }} />
              <p className="mt-3">{t('Home.Blog.NoPosts')}</p>
            </div>
          )}

          {!blogsLoading && blogs.length > 0 && (
            <Carousel interval={null} indicators={blogs.length > 4} className="blog-carousel">
              {blogs.reduce((chunks, _, i) => {
                if (i % 4 === 0) chunks.push(blogs.slice(i, i + 4));
                return chunks;
              }, []).map((group, idx) => (
                <Carousel.Item key={idx}>
                  <div className="row g-4 pb-2">
                    {group.map((blog) => (
                      <div className="col-12 col-sm-6 col-lg-3" key={blog.id}>
                        <Link to={`/blog/${blog.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          <div
                            style={{
                              background: 'white',
                              borderRadius: '14px',
                              overflow: 'hidden',
                              boxShadow: '0 2px 12px rgba(0,0,0,0.09)',
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              height: '100%',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-5px)';
                              e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.09)';
                            }}
                          >
                            {/* Cover image */}
                            {blog.coverImage ? (
                              <img
                                src={resolveAssetUrl(blog.coverImage)}
                                alt={blog.title}
                                style={{ width: '100%', height: '170px', objectFit: 'cover', display: 'block' }}
                                onError={(e) => { e.currentTarget.src = fallbackImg; }}
                              />
                            ) : (
                              <div style={{
                                height: '170px',
                                background: `linear-gradient(135deg,${categoryColors[blog.category] || '#6c757d'}22,${categoryColors[blog.category] || '#6c757d'}44)`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                              }}>
                                <i className="bi bi-journal-text" style={{ fontSize: '2.8rem', color: categoryColors[blog.category] || '#6c757d', opacity: 0.7 }} />
                              </div>
                            )}

                            <div style={{ padding: '16px' }}>
                              {/* Category badge */}
                              <span style={{
                                background: categoryColors[blog.category] || '#6c757d',
                                color: 'white',
                                padding: '2px 10px',
                                borderRadius: '999px',
                                fontSize: '10px',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                              }}>
                                {t(`Home.Blog.${blog.category.charAt(0).toUpperCase() + blog.category.slice(1)}`, blog.category)}
                              </span>

                              {/* Title */}
                              <h6 style={{
                                marginTop: '10px',
                                fontWeight: 700,
                                lineHeight: 1.4,
                                fontSize: '14px',
                                color: '#111827',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                              }}>
                                {blog.title}
                              </h6>

                              {/* Excerpt */}
                              {blog.excerpt && (
                                <p style={{
                                  fontSize: '12px',
                                  color: '#6b7280',
                                  marginTop: '6px',
                                  marginBottom: 0,
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                  lineHeight: 1.5,
                                }}>
                                  {blog.excerpt}
                                </p>
                              )}

                              {/* Footer */}
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginTop: '12px',
                                fontSize: '11px',
                                color: '#9ca3af',
                              }}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <i className="bi bi-person-circle" />
                                  {blog.author?.fullName || 'ENGPI'}
                                </span>
                                <span>{new Date(blog.createdAt).toLocaleDateString(i18n.language)}</span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </div>
      </section>
      {/* section 8 - Carousel for Home Page */}
      <section className="carousel-section py-5 reveal">
        <div className="container">
          <h1 className="section-title text-nowrap fs-1">  {t('Home.GalleryTitle')}</h1>
          <Carousel360
            images={[
              "/img/A1.png",
              "/img/A2.png",
              "/img/A3.png",
              "/img/A4.png",
              "/img/A5.png",
              "/img/A1.png",
              "/img/A2.png",
              "/img/A3.png",
              "/img/A4.png",
              "/img/A5.png"
            ]}
          />
        </div>
      </section>


      <Footer />
    </div>
  );
}
